












import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

import type { AlternativeButtonConfig } from '~/diptyqueTheme/types/components';

export default defineComponent({
  name: 'VaimoTruncatedToggle',
  components: {
    VaimoButton: () => import('atoms/VaimoButton.vue')
  },
  emits: ['toggle'],
  props: {
    alternativeButton: {
      type: Object as PropType<AlternativeButtonConfig>,
      default: null
    },
    label: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const buttonComponent = computed(() =>
      props.alternativeButton ? 'VaimoButton' : 'button'
    );

    const buttonClasses = computed(
      () => props.alternativeButton?.classes || 'vaimo-truncated-text__readmore'
    );

    const buttonVariant = computed<string | undefined>(
      () => props.alternativeButton?.variant
    );

    const buttonType = computed<'button' | undefined>(() =>
      props.alternativeButton ? undefined : 'button'
    );

    return {
      buttonComponent,
      buttonClasses,
      buttonVariant,
      buttonType
    };
  }
});
